<template>
	<div class="search row mb-3">
		<div class="col">
			<input type="search"
				   class="form-control"
				   :placeholder="placeholder"
				   :value="value"
				   @input="emitValue"
			/>
		</div>
		<div v-if="$slots.filter" class="col-1 text-center">
			<button class="btn" @click="showFilters = !showFilters">
				<i class="fas fa-filter"></i>
			</button>
			<div v-if="showFilters" class="filter-content">
				<slot name="filter"/>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "Search",
		props: {
			value: {
				type: String,
				default: ""
			},
			placeholder: {
				type: String,
				default: "Suche..."
			}
		},
		data() {
			return {
				showFilters: false,
			}
		},
		methods: {
			search(e) {
				e.preventDefault()
			},
			emitValue(e) {
				this.$emit('input', e.target.value)
			}
		}
	}
</script>

<style lang="scss">

	$fa-font-path: "../../assets/fonts";
	$img-path: "../../assets/img";
	@import "~cssteudter-bootstrap-theme/scss/main";

	.filter-content {
		@extend .position-absolute;
		@extend .shadow;
		@extend .text-left;
		@extend .bg-white;
		width: 300%;
		right: 45%;
		top: 45%;
		padding: $spacer;
		z-index: 1000;
	}
</style>
